import script from "./PlaceAd.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaceAd.vue?vue&type=script&setup=true&lang=js"

import "./PlaceAd.vue?vue&type=style&index=0&id=b77a5a70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b77a5a70"]])

export default __exports__